import { observer } from 'mobx-react-lite';
import { CSSTransition } from 'react-transition-group';

import styles from './Opponents.styles.m.css';
import { OpponentList } from './components/OpponentList/OpponentList';

const OpponentsCSSTransitionClasses = {
  enter: styles.opponentsEnter,
  enterActive: styles.opponentsEnterActive,
  exit: styles.opponentsExit,
  exitActive: styles.opponentsExitActive,
};

export const Opponents = observer(() => {
  return (
    <CSSTransition
      in={true}
      classNames={OpponentsCSSTransitionClasses}
      timeout={100}
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.container}>
        <OpponentList />
      </div>
    </CSSTransition>
  );
});
